<script lang="ts">
  import { onMount } from "svelte";
  import { navigate } from "../../app.logic";
  import TextareaUpload from "../../components/Form/Fields/TextareaUpload.svelte";
  import FormField from "../../components/Form/FormField.svelte";
  import FormLayout from "../../layout/FormLayout.svelte";
  import MainLayout from "../../layout/MainLayout.svelte";
  import type { IApiResponse } from "../../utils/api/api-response";
  import { initDetail, record, save } from "./challenge-task.store";
  import NumberInput from "../../components/Form/Fields/NumberInput.svelte";
  import type { IChallengeTask } from "../../entities/challenge-task";
  import Input from "../../components/Form/Fields/Input.svelte";
  import ChallengeDetailTabs from "./ChallengeDetailTabs.svelte";
  import Switch from "../../components/Form/Fields/Switch.svelte";

  export let challengeId: number;
  export let oid: number;

  $: isNew = oid == 0;
  $: canSubmit = $record != null && $record.points >= 0;

  async function onSubmit() {
    let newP = isNew;
    let _resp: IApiResponse<IChallengeTask> = await save();
    let u = _resp.payload;
    if (newP) {
      oid = u.oid;
      record.set(u);
      navigate(`/challenge/${challengeId}/tasks/${u.oid}`);
    } else {
      onCancel();
    }
  }

  function onCancel() {
    navigate(`/challenge/${challengeId}/tasks`);
  }

  function onSampleToggle(e: CustomEvent) {
    // zero points if it's a sample
    if (e.detail === 1 && $record != null) {
      $record.points = 0;
    }
  }

  onMount(() => initDetail(challengeId, oid));
</script>

<MainLayout>
  <ChallengeDetailTabs {challengeId} tasks={true} />

  {#if $record}
    <FormLayout {canSubmit} {isNew} on:submit={onSubmit} on:cancel={onCancel}>
      <div class="columns">
        <div class="column is-12">
          <FormField>
            <Input name="Name" placeholder="name" required={true} bind:value={$record.name} />
          </FormField>
        </div>
      </div>

      <div class="columns">
        <div class="column is-4">
          <FormField>
            <NumberInput name="Order" placeholder="order" required={true} bind:value={$record.order} />
          </FormField>
        </div>

        <div class="column is-4">
          <FormField>
            <NumberInput name="Points" placeholder="points" required={true} disabled={$record.sample == 1} bind:value={$record.points} />
          </FormField>
        </div>

        <div class="column is-4">
          <FormField>
            <Switch name="Sample" bind:value={$record.sample} on:toggle={onSampleToggle} />
          </FormField>
        </div>
      </div>

      <div class="columns">
        <div class="column">
          <FormField>
            <TextareaUpload name="Input" placeholder="input" required={false} monospace={true} bind:value={$record.input} />
          </FormField>
        </div>
      </div>

      <div class="columns">
        <div class="column">
          <FormField>
            <TextareaUpload name="Output" placeholder="output" required={false} monospace={true} bind:value={$record.output} />
          </FormField>
        </div>
      </div>
    </FormLayout>
  {/if}
</MainLayout>
